import React, { useState, useRef } from "react";

export default function PIPVideoPlayer() {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const videoRef = useRef(null);

  // Replace with your video URL
  const videoUrl = "/images/clarity.mp4";

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const closePlayer = () => {
    if (videoRef.current) {
      videoRef.current.pause();
    }
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      className={`fixed left-6 bottom-6 z-50 bg-black rounded-lg shadow-2xl transition-all duration-300 ${
        isExpanded
          ? "w-[90vw] max-w-[400px] h-[70vh] max-h-[700px]"
          : "w-[120px] h-[200px]"
      }`}
    >
      {/* Video Container */}
      <div className="relative w-full h-full">
        <video
          ref={videoRef}
          className="w-full h-full object-cover rounded-lg"
          controls={isExpanded}
          autoPlay
          loop
          muted
          playsInline
        >
          <source src={videoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* Control Buttons Overlay */}
        <div className="absolute top-2 right-2 flex gap-2">
          {/* Expand/Collapse Button */}
          <button
            onClick={toggleExpand}
            className="bg-black bg-opacity-60 hover:bg-opacity-80 text-white rounded-full p-2 transition-all duration-200"
            aria-label={isExpanded ? "Collapse video" : "Expand video"}
          >
            {isExpanded ? (
              // Minimize icon
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 9V4.5M9 9H4.5M9 9L3.75 3.75M9 15v4.5M9 15H4.5M9 15l-5.25 5.25M15 9h4.5M15 9V4.5M15 9l5.25-5.25M15 15h4.5M15 15v4.5m0-4.5l5.25 5.25"
                />
              </svg>
            ) : (
              // Maximize icon
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
                />
              </svg>
            )}
          </button>

          {/* Close Button */}
          <button
            onClick={closePlayer}
            className="bg-red-500 bg-opacity-80 hover:bg-opacity-100 text-white rounded-full p-2 transition-all duration-200"
            aria-label="Close video"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Play/Pause Overlay for Small Mode */}
        {!isExpanded && (
          <div
            className="absolute inset-0 flex items-center justify-center cursor-pointer"
            onClick={toggleExpand}
          >
            <div className="bg-black bg-opacity-40 rounded-full p-3 hover:bg-opacity-60 transition-all duration-200">
              <svg
                className="w-6 h-6 text-white"
                fill="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M8 5v14l11-7z" />
              </svg>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
